import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefVerificationStatus } from './interface/IRefVerificationStatus';

@Entity('ref_verification_status')
export class RefVerificationStatus
    extends BaseEntity
    implements IRefVerificationStatus
{
    apiMapping = {
        id: 'id',
        name: 'name',
    };

    @PrimaryGeneratedColumn()
    id: number;

    @Column()
    name: string;

    @Column({ nullable: true })
    isDeleted: boolean;
}
